var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dataView',{attrs:{"title":"הזמנות","collectionID":"ordersNextYear","dependant":['locations'],"allowNew":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }